module.exports = __webpack_public_path__ + "img/bottom.b451b8d1.png";